module.exports = __webpack_public_path__ + "img/TR.6a31c3af.png";